import { RoleType } from "../organisation/organisation.model";


export enum FeatureType{
    WORKSPACE_ACCESS = 'WORKSPACE_ACCESS',

    DASHBOARD_ACCESS = 'DASHBOARD_ACCESS',

    MEMBERS_ACCESS = 'MEMBERS_ACCESS',
    MEMBERS_EXPORT = 'MEMBERS_EXPORT',
    MEMBERS_EDIT = 'MEMBERS_EDIT',
    MEMBERS_DELETE = 'MEMBERS_DELETE',
    MEMBERS_PERSONAL_INFO = 'MEMBERS_PERSONAL_INFO',
    MEMBERS_EMPLOYMENT_INFO = 'MEMBERS_EMPLOYMENT_INFO',
    MEMBERS_SALARY_INFO = 'MEMBERS_SALARY_INFO',
    MEMBERS_MANAGE_RIGHTS = 'MEMBERS_MANAGE_RIGHTS',
    MEMBERS_MANAGE_ADMIN_RIGHTS = 'MEMBERS_MANAGE_ADMIN_RIGHTS',
    MEMBERS_TIMELINE = 'MEMBERS_TIMELINE',
    TEAMS = 'TEAMS',

    LEARNINGPLAN_REQUEST_ADD_MEMBERS = 'LEARNINGPLAN_REQUEST_ADD_MEMBERS',

    LEARNINGPLAN_ACCESS = 'LEARNINGPLAN_ACCESS',
    // The training requests (opleidingsaanvragen): seeing and processing them, by role and the member's own right.
    LEARNINGPLAN_REQUESTS_ACCESS = 'LEARNINGPLAN_REQUESTS_ACCESS',
    LEARNINGPLAN_BUDGET = 'LEARNINGPLAN_BUDGET',
    LEARNINGPLAN_EXPORT = 'LEARNINGPLAN_EXPORT',
    LEARNINGPLAN_EDIT = 'LEARNINGPLAN_EDIT',
    LEARNINGPLAN_COURSE_MEMBERS_ACCESS = 'LEARNINGPLAN_COURSE_MEMBERS_ACCESS',
    LEARNINGPLAN_COURSE_MEMBERS_EDIT = 'LEARNINGPLAN_COURSE_MEMBERS_EDIT',
    LEARNINGPLAN_COURSE_BUDGET_INFO = 'LEARNINGPLAN_COURSE_BUDGET_INFO',

    LEARNINGPLAN_COURSE_FORMS_ACCESS = 'LEARNINGPLAN_COURSE_FORMS_ACCESS',
    LEARNINGPLAN_COURSE_FORMS_EDIT = 'LEARNINGPLAN_COURSE_FORMS_EDIT',

    ANALYTICS_ACCESS = 'ANALYTICS_ACCESS',

    GRANTS_ACCESS = 'GRANTS_ACCESS',
    GRANTS_EDIT = 'GRANTS_EDIT',

    CERTIFICATES_ACCESS = 'CERTIFICATES_ACCESS',
    CERTIFICATES_EDIT = 'CERTIFICATES_EDIT',

    CERTIFICATION_ACCESS = 'CERTIFICATION_ACCESS',
    // The qualification catalogue, per type: what may be read, and what may be changed.
    CERTIFICATIONS_ACCESS = 'CERTIFICATIONS_ACCESS',
    CERTIFICATIONS_EDIT = 'CERTIFICATIONS_EDIT',
    QUALIFICATIONS_ACCESS = 'QUALIFICATIONS_ACCESS',
    // The qualification section by role alone, module or not: where it is sold to whoever lacks it.
    QUALIFICATIONS_SECTION_ACCESS = 'QUALIFICATIONS_SECTION_ACCESS',
    QUALIFICATIONS_SECTION_EDIT = 'QUALIFICATIONS_SECTION_EDIT',
    QUALIFICATIONS_EDIT = 'QUALIFICATIONS_EDIT',

    ENROLMENTS_ACCESS = 'ENROLMENTS_ACCESS',

    CONNECTIONS_ACCESS = 'CONNECTIONS_ACCESS',
    CONNECTIONS_EDIT = 'CONNECTIONS_EDIT',

    FORMS_ACCESS = 'FORMS_ACCESS',
    // The forms section itself: the same role as FORMS_ACCESS, but open without the module, so the
    // page that sells it can be read by whoever could buy it.
    FORMS_SECTION_ACCESS = 'FORMS_SECTION_ACCESS',

    SETTINGS_ACCESS = 'SETTINGS_ACCESS',

    FLA_ACCESS = 'FLA_ACCESS',

    FOD_WASO_ACCESS = 'FOD_WASO_ACCESS',

    ATTACHMENTS_ACCESS = 'ATTACHMENTS_ACCESS',
    ATTACHMENTS_EDIT = 'ATTACHMENTS_EDIT',

    CV_EMAIL_PDF = 'CV_EMAIL_PDF'
}

export interface Feature{
    type:FeatureType;
    roles:RoleType[];
    requiresAllRoles?:boolean;
    active:boolean;
    
}